import React from "react";

import BeatLoader from "react-spinners/BeatLoader";
import { Colors } from "../../../constant";
import "./styles.css";


  

export const LoadingScreen = () => {
  return (
    <>
      <div className="loading-container">
        <BeatLoader color={Colors.black} size={20}   />
      </div>

    </>
  );
};


